module.exports = __webpack_public_path__ + "img/EFishingBoat64_ua.495882eb.webp";